import squadcode from "../../../img/squadcode.png";
import "./Projectleftimage.css";

const Projectimage = () => {
  return <img src={squadcode} className="photossss reveal fade-left" />;
};

export default Projectimage;
